import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withModifiers as _withModifiers, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderSlot as _renderSlot, resolveComponent as _resolveComponent, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "SelectionCount" }
const _hoisted_2 = {
  key: 0,
  class: "WarningContainer"
}
const _hoisted_3 = { key: 0 }
const _hoisted_4 = { key: 0 }
const _hoisted_5 = { key: 1 }
const _hoisted_6 = { key: 2 }
const _hoisted_7 = { class: "ContentContainer" }
const _hoisted_8 = { class: "SelectionHelpersWrapper" }
const _hoisted_9 = { class: "ButtonContainer" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_MassEditModal = _resolveComponent("MassEditModal")!

  return (_openBlock(), _createElementBlock("section", {
    class: _normalizeClass(["MassSelectionOverview", { isVisible: _ctx.isVisible }])
  }, [
    _createElementVNode("div", {
      class: _normalizeClass(["Header", {
				ContentHidden: !_ctx.contentVisible,
				PreventContentSlideUp: _ctx.preventContentSlideUp
			}])
    }, [
      _cache[6] || (_cache[6] = _createElementVNode("div", { class: "TopLine" }, null, -1 /* CACHED */)),
      _createElementVNode("div", {
        class: "Title",
        onClick: _cache[0] || (_cache[0] = _withModifiers(($event: any) => (_ctx.toggleContentVisible()), ["prevent"]))
      }, [
        _cache[3] || (_cache[3] = _createTextVNode(" Enrolment(s) selected : ")),
        _createElementVNode("span", _hoisted_1, _toDisplayString(_ctx.selectedItemsCounter), 1 /* TEXT */),
        _cache[4] || (_cache[4] = _createElementVNode("i", { class: "lnr-chevron-down IconNoteChevronDown" }, null, -1 /* CACHED */)),
        _cache[5] || (_cache[5] = _createElementVNode("i", { class: "lnr-chevron-up IconNoteChevronUp" }, null, -1 /* CACHED */))
      ])
    ], 2 /* CLASS */),
    _createElementVNode("div", {
      class: _normalizeClass(["Content", { ContentHidden: !_ctx.contentVisible }])
    }, [
      (_ctx.multipleStatusesWarningShown || _ctx.multipleOrganisationsWarningShown)
        ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
            _cache[9] || (_cache[9] = _createElementVNode("i", { class: "lnr-notification-circle WarningIcon" }, null, -1 /* CACHED */)),
            (_ctx.multipleStatusesWarningShown || _ctx.multipleOrganisationsWarningShown)
              ? (_openBlock(), _createElementBlock("span", _hoisted_3, [
                  _cache[7] || (_cache[7] = _createTextVNode(" Enrolments with different ")),
                  (_ctx.multipleStatusesWarningShown)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_4, "statuses"))
                    : _createCommentVNode("v-if", true),
                  (_ctx.multipleStatusesWarningShown && _ctx.multipleOrganisationsWarningShown)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_5, "and"))
                    : _createCommentVNode("v-if", true),
                  (_ctx.multipleOrganisationsWarningShown)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_6, "organisations"))
                    : _createCommentVNode("v-if", true),
                  _cache[8] || (_cache[8] = _createTextVNode(" have been selected. "))
                ]))
              : _createCommentVNode("v-if", true)
          ]))
        : _createCommentVNode("v-if", true),
      _createElementVNode("div", _hoisted_7, [
        _createElementVNode("div", _hoisted_8, [
          (!_ctx.isContentFocused)
            ? (_openBlock(), _createElementBlock("button", {
                key: 0,
                class: "Textlink",
                onClick: _cache[1] || (_cache[1] = _withModifiers(($event: any) => (_ctx.clearSelection()), ["prevent"]))
              }, _cache[10] || (_cache[10] = [
                _createElementVNode("i", { class: "lnr-cross ClearSelectionIcon" }, null, -1 /* CACHED */),
                _createTextVNode(" Clear selection ")
              ])))
            : _createCommentVNode("v-if", true),
          (_ctx.multipleItemsSelected)
            ? (_openBlock(), _createElementBlock("button", {
                key: 1,
                class: "Textlink",
                onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.openMassEditModal && _ctx.openMassEditModal(...args)))
              }, _cache[11] || (_cache[11] = [
                _createElementVNode("i", { class: "lnr-pencil ClearSelectionIcon" }, null, -1 /* CACHED */),
                _createTextVNode(" Mass edit ")
              ])))
            : _createCommentVNode("v-if", true)
        ]),
        _createElementVNode("div", _hoisted_9, [
          _renderSlot(_ctx.$slots, "default")
        ])
      ])
    ], 2 /* CLASS */),
    (_ctx.isMassEditModalShown)
      ? (_openBlock(), _createBlock(_component_MassEditModal, { key: 0 }))
      : _createCommentVNode("v-if", true)
  ], 2 /* CLASS */))
}